import { avoidBreakInside } from '@provider/print';
import { useTaskContext } from '../../context.js';
import { input } from './input.style.js';
import { jsx } from 'react/jsx-runtime';

function ReadonlyInput(props) {
  const context = useTaskContext();
  return /*#__PURE__*/jsx("div", {
    className: input,
    "data-readonly": true,
    "data-context": context,
    "data-facit": props.isFacit,
    ...avoidBreakInside(),
    children: props.text
  });
}

export { ReadonlyInput };
//# sourceMappingURL=input.readonly.js.map
